import React from 'react';
import {Button} from 'primereact/button'

// import Questionnaire from "./Questionnaire";
// import history from "../RouterWithAcess/history";
import { TabPanel, TabView } from 'primereact/tabview';
import { useNavigate } from 'react-router-dom';


function Questionnaires(){
    // const [answerClick] =React.useState(false)
    const navigate = useNavigate();
    return(
        <div className="grid main-box">
            <Button
                label="Create New Risk Assessment"
                className="p-button-sm btn4"
                onClick={(e) => navigate("/createAssessment")}
                />
            <TabView activeIndex={0}>
            <TabPanel header = "Questionnaires">
            {/* <div className="flex align-items-center justify-content-between">
                <div><h2>Questionnaires</h2></div>
                <div>
                    <Button
                        label="Create New Survey"
                        className="p-button-sm btn3"
                        onClick={(e) => navigate("/createPoll")}
                    />
                </div>
            </div> */}
            
            <div className="pl-0 pt-2">
            {
                Array(5).fill(0).map((item, index) => 
                    <div className="grid" key={index}>
                        <div className="col-fixed" style={{width : "80px"}}>
                            <div className="box text-center">{index + 1}</div>
                        </div>
                        <div className = "col">
                            <div className="flex align-items-center box">
                                <div style={{fontWeight : 700, width : "50%", flexGrow : 1}}>Investment Questionnaire</div>
                                <span className="floatRight" style={{fontSize:"0.9rem"}}>Meeting Name : <span>Soyabean Oil Assesment</span></span>
                                    <span
                                        className="expand"
                                        onClick={() => {
                                        // this.setDeleteItem(item)
                                        // this.setDeleteDialog(true)
                                        navigate("/Questionnaires/1")
                                        }}
                                    >
                                        Answer
                                    </span> 
                                {/* <div className="floatRight">  */}
                                    <span
                                        className="expand"
                                        onClick={() => {
                                        // this.setDeleteItem(item)
                                        // this.setDeleteDialog(true)
                                        navigate("/pollResults")
                                        }}
                                    >
                                        View Results
                                    </span>
                                {/* </div> */}
                            </div>
                        </div>
                    </div>
                )
            }  
            </div>
            {/* <div className="pl-3 pt-3">
                <div className="box grid spacing1">
                    <div className="col-9">
                        <span style={{fontWeight : 600}}>Investment Questionnaire</span>
                    </div>
                    <div className="col">
                        <span
                            className="expand"
                            onClick={() => {
                            // this.setDeleteItem(item)
                            // this.setDeleteDialog(true)
                            navigate("/Questionnaires/1")
                            }}
                        >
                            Answer
                        </span>
                    </div>
                    <div className="col">
                        <span
                            className="expand"
                            onClick={() => {
                            // this.setDeleteItem(item)
                            // this.setDeleteDialog(true)
                            }}
                        >
                            Result
                        </span>
                    </div>
                </div>
            </div> */}
            </TabPanel></TabView>
        </div>
    )
}

export default Questionnaires
